import { useTranslation } from "react-i18next";
import type { PlannedStartDto } from "../../autogen/bff-api";

export const usePlannedStartLabel = () => {
  const { i18n } = useTranslation();
  return (start: PlannedStartDto): string =>
    new Intl.DateTimeFormat(i18n.language?.startsWith("no") ? "nb-NO" : "en-GB", {
      month: "long",
      year: "numeric",
    }).format(new Date(start.year, start.month - 1, 1));
};

export const upcomingMonths = (today: Date, count: number): PlannedStartDto[] =>
  Array.from({ length: count }, (_, i) => {
    const date = new Date(today.getFullYear(), today.getMonth() + i, 1);
    return { year: date.getFullYear(), month: date.getMonth() + 1 };
  });

export const plannedStartKey = (start: PlannedStartDto): string => `${start.year}-${start.month}`;
